import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  ReadNotification(otp): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/notification/read`, {otp: otp});
  }

  UpdateNotification(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/notification/update`, {otp: otp});
  }
}
